import { RestrictionFeature } from "../../../../types";

export const shouldShowBar = (
  data: RestrictionFeature.RestrictionBarData,
  restrictionContext: "Staff" | "Patron"
) => {
  if (
    (restrictionContext === "Staff" && data.rule.staffOverride === "FULL") ||
    (!data.rule.countLimit && !data.willViolate) ||
    (!data.willViolate && !data.rule.countLimit?.showNonViolating)
  ) {
    return false;
  }
  return true;
};
